import { FC, Fragment, JSX } from 'react';
import { Box, Typography } from '@mui/material';
// components
import DvConstraintTable from './DvConstraintTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { DV_CONSTRAINTS_TEXT } from 'constants/index';

const DvConstraints: FC = (): JSX.Element => {
  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{DV_CONSTRAINTS_TEXT}</Typography>
      </Box>
      <DvConstraintTable />
    </Fragment>
  );
};

export default DvConstraints;
